import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  tickets: { count: 0, data: [], num_pages: 1, page: 1, page_size: "5" },
};

const slice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET TICKETS
    getTicketsSuccess(state, action) {
      state.isLoading = false;
      state.tickets = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions

// ----------------------------------------------------------------------
const appCurrency = localStorage.getItem("app-currency");
export function getTickets(
  page = 1,
  rowsPerPage = 5,
  filterStartDate,
  filterEndDate,
  filterUser,
  filterName,
  filterProvider
) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/v1/dashboard/tickets?page=${page}&page_size=${rowsPerPage}&start_date=${filterStartDate}&end_date=${filterEndDate}&user=${filterUser}&ref_code=${filterName}&provider=${filterProvider}&currency=${appCurrency}`
      );
      dispatch(slice.actions.getTicketsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function getTicket(keyId) {
  const response = await axios.get(
    `/api/v1/dashboard/ticket-id?keyId=${keyId}`
  );
  return response.data;
}

export async function getTicketTransactionId(keyId) {
  const response = await axios.get(
    `/api/v1/dashboard/ticket-transaction-id?keyId=${keyId}`
  );
  return response.data;
}

export async function postCancelTicket(transaction_id, password) {
  const response = await axios.post(`/api/v1/dashboard/cancel-ticket`, {
    transaction_id,
    password,
  });
  return response.data;
}

export async function updateTicketBeneficiary(id, data) {
  const response = await axios.put(
    `/api/v1/dashboard/ticket/${id}/beneficiary`,
    data
  );
  return response.data;
}
